import { RootState } from '../store';

export const rootSelector = (state: RootState) => state.projectOnboarding;

export const getProjectDetailsFromState = (state: RootState) =>
    rootSelector(state)?.projectDetails;

export const getUsersListFromState = (state: RootState) =>
    rootSelector(state)?.userList.users;

export const getUpdateProjectFromState = (state: RootState) =>
    rootSelector(state)?.updateProject;

export const getSkillsFromState = (state: RootState) =>
    rootSelector(state)?.skills;
